import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import styles from "./PageNotFound.module.scss";
import * as Path from "../../Constants/GlobalConstant";

const PageNotFound = (props) => {
    const intl = useIntl();

    window.scrollTo(0, 0);

    return (
        <div className={styles.notFound}>
            <img src="images/error404.png" alt="page not found" />
            <h4>
                <Link to={Path.HOME_PATH}>{intl.messages.pageNotFoundLink}</Link>
            </h4>
        </div>
    );
}

export default PageNotFound;